"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useYouTubeInfo = void 0;
var react_1 = require("react");
var util_1 = require("@aperza/util");
var key = 'AIzaSyAuwdMg7BWqk6FXmYAMm3OGGJIrbFSkvxU';
var env = util_1.EnvUtil.getAppEnv();
if (env === util_1.EnvUtil.ENV_TEST || env === util_1.EnvUtil.ENV_STORYBOOK) {
    key = 'AIzaSyA5qRKXMuT7sL-Ho5dTgtj44G2dGROy6ho';
}
else if (env === util_1.EnvUtil.ENV_TEST_2) {
    key = 'AIzaSyA5qRKXMuT7sL-Ho5dTgtj44G2dGROy6ho';
}
else if (env === util_1.EnvUtil.ENV_STG) {
    key = 'AIzaSyAknYVSYzz3IGZ22AX_9_hBgkuffGJtyww';
}
else if (env === util_1.EnvUtil.ENV_PROD) {
    key = 'AIzaSyAuwdMg7BWqk6FXmYAMm3OGGJIrbFSkvxU';
}
var useYouTubeInfo = function (videoId) {
    var _a = __read(react_1.useState({}), 2), video = _a[0], setVideo = _a[1];
    var _b = __read(react_1.useState(false), 2), loadingVideoInfo = _b[0], setLoadingVideoInfo = _b[1];
    var loadVideoInfo = function (_videoId) {
        if (_videoId === undefined || _videoId === null || _videoId.length === 0)
            return;
        var outputPart = 'snippet,statistics';
        var url = "https://www.googleapis.com/youtube/v3/videos?key=" + key + "&id=" + _videoId + "&part=" + outputPart;
        setLoadingVideoInfo(true);
        return fetch(url)
            .then(function (response) {
            if (response.status >= 400) {
                throw new Error('Bad response from server');
            }
            setLoadingVideoInfo(false);
            return response.json();
        })
            .then(function (data) {
            if (Array.isArray(data.items) && data.items.length > 0) {
                var item = data.items[0];
                setVideo({
                    videoId: item.id,
                    title: item.snippet.title,
                    thumbnailUrl: item.snippet.thumbnails.default.url,
                    authorName: item.snippet.channelTitle,
                    viewCount: item.statistics.viewCount,
                    publishedAt: item.snippet.publishedAt,
                    tags: item.snippet.tags,
                    videoUrl: "https://www.youtube.com/embed/" + _videoId + "?&autoplay=1&rel=0",
                });
            }
            setLoadingVideoInfo(false);
        })
            .catch(function (error) {
            console.error(error);
            setLoadingVideoInfo(false);
        });
    };
    react_1.useEffect(function () {
        loadVideoInfo(videoId);
    }, [videoId]);
    return {
        video: video,
        loadingVideoInfo: loadingVideoInfo,
        setVideoId: function (_videoId) { return loadVideoInfo(_videoId); },
    };
};
exports.useYouTubeInfo = useYouTubeInfo;
//# sourceMappingURL=UseYouTubeInfo.js.map